import { AxiosError } from 'axios';
import type { FailureResponse } from '@/models';

const FALLBACK_MESSAGE = 'Something went wrong. Please try again.';
const NETWORK_MESSAGE = 'Cannot reach the server. Check your connection and try again.';

export class ApiError extends Error {
  code: string;
  exceptionName: string;
  status?: number;

  constructor(message: string, code = 'unknownError', exceptionName = 'UnknownError', status?: number) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.exceptionName = exceptionName;
    this.status = status;
  }
}

/** Normalizes anything thrown by an API call into an ApiError with a user-facing message. */
export function toApiError(err: unknown): ApiError {
  if (err instanceof ApiError) return err;

  if (err instanceof AxiosError) {
    const failure = (err.response?.data as FailureResponse | undefined)?.failureMessage;
    if (failure?.exceptionMessage) {
      return new ApiError(
        failure.exceptionMessage,
        failure.exceptionCode,
        failure.exceptionName,
        err.response?.status,
      );
    }
    if (!err.response) return new ApiError(NETWORK_MESSAGE, 'networkError', 'NetworkError');
    return new ApiError(FALLBACK_MESSAGE, 'unknownError', 'UnknownError', err.response.status);
  }

  return new ApiError(err instanceof Error && err.message ? err.message : FALLBACK_MESSAGE);
}
